import { connect } from 'react-redux';
import { Button, IconSettings, Card } from '@salesforce/design-system-react';
import CustomToastContainer from '../../Components/App/CustomToastContainer';
import CompanyGoal from '../../Components/BusinessChallenge/CompanyGoal';
import BusinessInstructions from '../../Components/Sidebars/Instructions/BusinessInstructions';
import BusinessMethod from '../../Components/BusinessChallenge/BusinessMethod';
import VidyardEmbed from '@vidyard/embed-code';
import { socket } from './../../socket';
import React, { useEffect } from 'react';
import Sidebar from '../../Components/Sidebars/App/Sidebar';
import Banner from '../../Components/App/Banner';
import SocketListeners from '../../Components/App/SocketListeners';
import PageBlockHeader from '../../Components/PageBlockHeader';

import {
  updateBusinessChallenge,
  assembleFullChallenge,
  addCompanyGoal,
  addMeasureOne,
  addMeasureTwo,
  addMeasureThree,
  setStepId,
  addToast,
  addBusinessChallengeDBOnly,
  setBusinessChallenge
} from '../../actions';

function BusinessChallenge (props) {
  useEffect(() => { 
    VidyardEmbed.api.renderDOMPlayers();

   // socket.emit('onLoadServer', props.journeyId); // Adds to room.
    socket.emit('onAddActiveCollaboratorServer',{ "journeyId": props.journeyId, "email": props.username } );
  }, []);


  const nextScreen = () => {
    props.setStepId(2);

    props.history.push('/BusinessChallenge');

    window.location.href = '/Personas';
  };

  const goToEntry = () => {
    props.history.push('/BusinessChallenge');

    window.location.href = '/';
  }

  const updateFields = async() => {
    const fullChallenge = `How might we ${props.companyGoal} by ${props.measureOne}, ${props.measureTwo}, and ${props.measureThree}`;

    await props.addBusinessChallengeDBOnly(props.journeyId, props.businessChallengeId, props.companyGoal, props.measureOne, props.measureTwo, props.measureThree, fullChallenge);
  }

  const addEverything = async (e) => {
    e.preventDefault();

    if (
      props.companyGoal === '' ||
      props.measureOne === '' ||
      props.measureTwo === '' ||
      props.measureThree === ''
    ) {
      props.addToast({
        labels: {
          heading: 'Please make sure fill out all business challenge fields',
        },
        variant: 'error',
      });
    } else {
      await updateFields();

      nextScreen();
    }
  };
    
    return (
      <IconSettings iconPath="/icons">
        <CustomToastContainer />
        <div className="outer-container">
          <Sidebar 
            stage="Business Challenge"
            instructions={<BusinessInstructions />}
          />
          <Banner
            backgroundColor='#D8E6FE'
            previous={goToEntry}
            next={addEverything}
            stage="Business Challenge"
            backgroundImage='/Images/Banners/HeroBanners-02.png'
          />
          <div>
            {/*<SocketListeners />*/}
            <div style={{ marginLeft: 'max(210px, 15%)'}}>
              <div className="slds-p-vertical_medium slds-p-horizontal_x-large">
                <Card
                  className="slds-m-top_x-small"
                  header={
                    <div className="slds-grid" style={{ width: '100%'}}>
                      <div className="slds-size_9-of-12">
                        <PageBlockHeader
                          hasBorder={false}
                          title={`Define `}
                          addtl={`Business Challenge`}
                          subtitle={`Step 1: Finalize a company goal. Step 2: Create three methods to success.`}
                        />
                      </div>
                      <div className="slds-size_3-of-12">
                        <Button
                          label="Update Business Challenge"
                          variant="outline-brand"
                          onClick={updateFields}
                        />
                        <Button 
                          label="Next Stage" 
                          variant="brand" 
                          onClick={addEverything}
                        />
                      </div>
                    </div>
                  }
                >
                  <div className="slds-p-horizontal_medium">
                    <div
                      className="slds-text-heading_large margin-b"
                    >
                      How might we
                    </div>

                    <CompanyGoal
                      className="margin-b"
                      value={props.companyGoal}
                      onChange={(e) => {
                        if (e.target.value.length < 256) {
                          props.addCompanyGoal(e.target.value);
                        } else {
                          props.addToast({
                            labels: {
                              heading:
                                'Company goal needs to be 255 or less characters.',
                            },
                            variant: 'error',
                          });
                        }
                      }}
                    />

                    <div className="slds-text-heading_large margin-b">by</div>
                    <div className="slds-grid slds-gutters">
                    <BusinessMethod
                      value={props.measureOne}
                      onChange={(e) => {
                        if (e.target.value.length < 256) {
                          props.addMeasureOne(e.target.value);
                        } else {
                          props.addToast({
                            labels: {
                              heading:
                                'All methods needs to be 255 or less characters.',
                            },
                            variant: 'error',
                          });
                        }
                      }}
                    >
                      <i>
                        Then add a method you plan to use to achieve the
                        customer's goal. Examples include "streamlining
                        operational processes" or "improving employee
                        retention".
                      </i>
                    </BusinessMethod>
                    <BusinessMethod
                      value={props.measureTwo}
                      onChange={(e) => {
                        if (e.target.value.length < 256) {
                          props.addMeasureTwo(e.target.value);
                        } else {
                          props.addToast({
                            labels: {
                              heading:
                                'All methods needs to be 255 or less characters.',
                            },
                            variant: 'error',
                          });
                        }
                      }}
                    >
                      <i>
                        If you have a second method to achieve the customer's
                        goal, please list it here.
                      </i>
                    </BusinessMethod>
                    <BusinessMethod
                      value={props.measureThree}
                      onChange={(e) => {
                        if (e.target.value.length < 256) {
                          props.addMeasureThree(e.target.value);
                        } else {
                          props.addToast({
                            labels: {
                              heading:
                                'All methods needs to be 255 or less characters.',
                            },
                            variant: 'error',
                          });
                        }
                      }}
                    >
                      <i>
                        If you have a third method to achieve the customer's
                        goal, please list it here.
                      </i>
                    </BusinessMethod>
                  </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </IconSettings>
    );
  }


const mapStateToProps = (state) => ({
  journeyId: state.app.journeyId,
  username: state.app.username,
  businessChallengeId: state.businessChallenge.id,
  companyGoal: state.businessChallenge.companyGoal,
  measureOne: state.businessChallenge.measureOne,
  measureTwo: state.businessChallenge.measureTwo,
  measureThree: state.businessChallenge.measureThree,
  fullChallenge: state.businessChallenge.fullChallenge,
});

const mapDispatchToProps = (dispatch) => ({
  // -- ADD IDEA START --
  addBusinessChallengeDBOnly: (journeyId, businessChallengeId, companyGoal, measureOne, measuureTwo, measureThree, fullChallenge) =>
  dispatch(addBusinessChallengeDBOnly(journeyId, businessChallengeId, companyGoal, measureOne, measuureTwo, measureThree, fullChallenge)),
  setBusinessChallenge: (challenge) => 
  dispatch(setBusinessChallenge(challenge)),
  // -- ADD IDEA END -- 


  setStepId: (stepId) => dispatch(setStepId(stepId)),
  addCompanyGoal: (companyGoal) => dispatch(addCompanyGoal(companyGoal)),
  addMeasureOne: (measureOne) => dispatch(addMeasureOne(measureOne)),
  addMeasureTwo: (measureTwo) => dispatch(addMeasureTwo(measureTwo)),
  addMeasureThree: (measureThree) => dispatch(addMeasureThree(measureThree)),
  assembleFullChallenge: (fullChallenge) =>
    dispatch(assembleFullChallenge(fullChallenge)),
  updateBusinessChallenge: (
    businessChallengeId,
    journeyId,
    fullChallenge,
    companyGoal,
    methodOne,
    methodTwo,
    methodThree
  ) =>
    dispatch(
      updateBusinessChallenge(
        businessChallengeId,
        journeyId,
        fullChallenge,
        companyGoal,
        methodOne,
        methodTwo,
        methodThree
      )
    ),
  addToast: (toast) => dispatch(addToast(toast)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BusinessChallenge);
